import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QRCodeModule } from 'angularx-qrcode';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { ButtonComponent } from './button/button.component';
import { CardPanelComponent } from './card-panel/card-panel.component';
import { ChipListItemComponent } from './chip-list/chip-list-item/chip-list-item.component';
import { ChipListComponent } from './chip-list/chip-list.component';
import { DataTableComponent } from './data-table/data-table.component';
import { DemoComponent } from './demo/demo.component';
import { DialogGenericComponent } from './dialog-generic/dialog-generic.component';
import { DisableTableOnRefreshDirective } from './directives/disable-table-on-refresh.directive';
import { RotateRefreshOnHttpDirective } from './directives/rotate-refresh-on-http.directive';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { FormInputGroupComponent } from './form-input-group/form-input-group.component';
import { GlobalLoadingSpinnerComponent } from './global-loading-spinner/global-loading-spinner.component';
import { ImageUploaderComponent } from './image-uploader/image-uploader.component';
import { InfoTableComponent } from './info-table/info-table.component';
import { InfoTooltipComponent } from './info-tooltip/info-tooltip.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { MultiSelectTextComponent } from './multi-select-text/multi-select-text.component';
// import { RolePipe } from './pipes/role.pipe';
import { QrLabelComponent } from './qr-label/qr-label.component';
import { SectionTitleComponent } from './section-title/section-title.component';
import { SuccessMessageComponent } from './success-message/success-message.component';
import { TabPanelComponent } from './tab-panel/tab-panel.component';
import { ToggleComponent } from './toggle/toggle.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { InfoPropertyTableComponent } from './info-property-table/info-property-table.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { ProgressBarSellerComponent } from './progress-bar-seller/progress-bar-seller.component';
import { ProgressBarBuyerComponent } from './progress-bar-buyer/progress-bar-buyer.component';
import { ProgressBarBuyerPayerComponent } from './progress-bar-buyer-payer/progress-bar-buyer-payer.component';
import { DocumentsComponent } from './documents/documents.component';
import { PriceComponent } from './price-object/price.component';
import { AccordionComponent } from './accordion/accordion.component';
import { InfoTableMultirowComponent } from './info-table-multirow/info-table-multirow.component';
import { EuroSign } from './pipes/eurosign.pipe';
import { SubmitableTableComponent } from './submitable-table/submitable-table.component';
import { DocumentsSubmitableComponent } from './documents-submitable/documents-submitable.component';
import { AccordionSubmitbleComponent } from './accordion-submitable/accordion-submitable.component';
import { DocumentsNamePipe } from './pipes/documents.pipe';
import { RecursiveCompComponent } from './recursive-comp/recursive-comp.component';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { CadastreAttachmentTableComponent } from './cadastre-attachment-table/cadastre-attachment-table.component';

import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AdditionalCertificatesTableComponent } from './additional-certificates-table/additional-certificates-table.component';

const MAT_MODULES = [
    MatTableModule,
    MatSelectModule,
    MatIconModule,
    MatInputModule,
    MatCheckboxModule,
];

const SHARED_MODULES = [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    HttpClientModule,
    QRCodeModule,
    ...MAT_MODULES,
];
const SHARED_COMPONENTS = [
    BreadcrumbComponent,
    ImageUploaderComponent,
    MultiSelectTextComponent,
    QrLabelComponent,
    SuccessMessageComponent,
    ErrorMessageComponent,
    ChipListComponent,
    ChipListItemComponent,
    InfoTooltipComponent,
    DialogGenericComponent,
    CardPanelComponent,
    InfoTableComponent,
    SectionTitleComponent,
    TabPanelComponent,
    DataTableComponent,
    FormInputGroupComponent,
    ButtonComponent,
    DemoComponent,
    UserInfoComponent,
    // RolePipe,
    EuroSign,
    DocumentsNamePipe,
    LoadingSpinnerComponent,
    RotateRefreshOnHttpDirective,
    DisableTableOnRefreshDirective,
    ToggleComponent,
    GlobalLoadingSpinnerComponent,
    InfoPropertyTableComponent,
    ProgressBarComponent,
    ProgressBarSellerComponent,
    ProgressBarBuyerComponent,
    ProgressBarBuyerPayerComponent,
    DocumentsComponent,
    DocumentsSubmitableComponent,
    PriceComponent,
    AccordionComponent,
    InfoTableMultirowComponent,
    SubmitableTableComponent,
    AccordionSubmitbleComponent,
    RecursiveCompComponent,
    CadastreAttachmentTableComponent,
    AdditionalCertificatesTableComponent
];

const SHARED_ENTRY_COMPONENTS = [DialogGenericComponent];

@NgModule({
    imports: [...SHARED_MODULES],
    declarations: [...SHARED_COMPONENTS],
    exports: [...SHARED_MODULES, ...SHARED_COMPONENTS],
    providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'fill' },
        },
    ],
    entryComponents: [...SHARED_ENTRY_COMPONENTS],
})
export class SharedModule {}
